import React from "react";

// Coin-shaped SVG: gold disc with an engraved crowned pawn.
// Usage: <CrownCoin size={20} /> <CrownCoin size={32} shimmer /> <CrownCoin earn />
export default function CrownCoin({ size = 20, shimmer = false, earn = false, style = {} }) {
  const g = `cc${size}`;
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24"
      className={earn ? "crown-earn" : shimmer ? "crown-shimmer" : ""}
      style={{ flexShrink: 0, display: "inline-block", verticalAlign: "middle", ...style }}
      aria-hidden="true"
    >
      <defs>
        {/* Main gold radial — bright top-left, deep bottom-right */}
        <radialGradient id={`${g}a`} cx="36%" cy="30%" r="68%">
          <stop offset="0%"   stopColor="#FFF5B0"/>
          <stop offset="35%"  stopColor="#D4AF37"/>
          <stop offset="75%"  stopColor="#A07800"/>
          <stop offset="100%" stopColor="#6E4D00"/>
        </radialGradient>
        {/* Specular highlight overlay */}
        <radialGradient id={`${g}b`} cx="32%" cy="26%" r="45%">
          <stop offset="0%"   stopColor="#FFFFFF" stopOpacity="0.45"/>
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0"/>
        </radialGradient>
        {/* Violet accent for inner ring — subtle brand touch */}
        <linearGradient id={`${g}c`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%"   stopColor="#9B87F5" stopOpacity="0.25"/>
          <stop offset="100%" stopColor="#D4AF37" stopOpacity="0.15"/>
        </linearGradient>
      </defs>

      {/* Coin disc */}
      <circle cx="12" cy="12" r="11.5" fill={`url(#${g}a)`}/>
      {/* Specular */}
      <circle cx="12" cy="12" r="11.5" fill={`url(#${g}b)`}/>
      {/* Inner emboss ring */}
      <circle cx="12" cy="12" r="10" fill="none" stroke="#8A6600" strokeWidth="0.55" opacity="0.5"/>
      {/* Subtle violet inner ring (brand accent) */}
      <circle cx="12" cy="12" r="10" fill="none" stroke={`url(#${g}c)`} strokeWidth="0.55"/>

      {/* ── Crowned pawn engraving ── */}
      {/* Crown: base bar + 3 spikes + 3 tip dots */}
      <g fill="#7A5500" opacity="0.88">
        <rect x="8" y="12.4" width="8" height="1.9" rx="0.5"/>
        <polygon points="8.6,12.4 9.8,9.2 11,12.4"/>
        <polygon points="11,12.4 12,8.8 13,12.4"/>
        <polygon points="13,12.4 14.2,9.2 15.4,12.4"/>
        <circle cx="9.8"  cy="9.2"  r="0.65"/>
        <circle cx="12"   cy="8.8"  r="0.65"/>
        <circle cx="14.2" cy="9.2"  r="0.65"/>
      </g>

      {/* Pawn head */}
      <circle cx="12" cy="16.3" r="1.85" fill="#7A5500" opacity="0.88"/>
      {/* Pawn body (pedestal) */}
      <path
        d="M9.5 21.2 C9.8 19.4 10.7 18.5 12 18.3 C13.3 18.5 14.2 19.4 14.5 21.2Z"
        fill="#7A5500" opacity="0.88"
      />
    </svg>
  );
}
